import { memo } from 'react';

import { FiLayers } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { UseQueryResult } from 'react-query';
import { AxiosError } from 'axios';

import { SponsorsData, SponsorsResult } from '@common/types/api';

import * as S from './styles';

type SponsorsSectionProps = {
  sponsorsQuery: UseQueryResult<SponsorsResult, AxiosError>;
};

const SponsorCardItem = ({ sponsor }: { sponsor: SponsorsData }) => (
  <S.SponsorCard>
    <Link to={`/sponsors/${sponsor.id}`}>
      <S.SponsorLogo className="logo-inner">
        <img src={sponsor.logo} alt={sponsor.name} loading="lazy" />
      </S.SponsorLogo>
    </Link>
  </S.SponsorCard>
);

const SponsorsSection = ({ sponsorsQuery }: SponsorsSectionProps) => {
  const { t } = useTranslation();

  if (!sponsorsQuery.isSuccess || !sponsorsQuery.data?.sponsors?.length) {
    return null;
  }

  const { sponsors } = sponsorsQuery.data;

  const tier1 = sponsors.slice(0, 2);
  const tier2 = sponsors.slice(2);

  return (
    <div style={{ marginBottom: '2.95rem' }}>
      <S.Header>
        <S.HeaderLeft>
          <FiLayers size={20} />
          <h2>{t('pages.sponsors.title')}</h2>
        </S.HeaderLeft>
      </S.Header>

      {tier1.length > 0 && (
        <S.Tier1Grid>
          {tier1.map((sponsor) => (
            <SponsorCardItem key={`sponsor-${sponsor.id}`} sponsor={sponsor} />
          ))}
        </S.Tier1Grid>
      )}

      {tier2.length > 0 && (
        <S.Tier2Grid>
          {tier2.map((sponsor) => (
            <SponsorCardItem key={`sponsor-${sponsor.id}`} sponsor={sponsor} />
          ))}
        </S.Tier2Grid>
      )}
    </div>
  );
};

export default memo(SponsorsSection);
